import React, {
  useContext,
  useMemo,
  useEffect,
} from 'react';

import FeedContext from '../../../../context/FeedContext';
import { actionBarType } from '../../../../context/FeedContext/config/actionBarTypes';
import LayoutContext from '../../../../layout/context/LayoutContext';
import ChatSideBar from '../../../Chat/components/ChatSideBar';

import MobileView from './MobileView';
import CheckInFeedback from './CheckInFeedback';
import ExerciseFeedback from './ExerciseFeedback';
import {
  StyledChatView,
  ChatSideBarContainer,
} from './styles';

const FeedActionBarContent = () => {
  const {
    selectedActionBarType,
  } = useContext(FeedContext);

  const content = useMemo(() => {
    switch (selectedActionBarType) {
      case actionBarType.CHAT:
        return <StyledChatView />;
      case actionBarType.MOBILE_VIEW:
        return <MobileView />;
      case actionBarType.CHECK_IN_FEEDBACK:
        return <CheckInFeedback />;
      case actionBarType.EXERCISE_VIDEO_FEEDBACK:
        return <ExerciseFeedback />;
      default:
        // Show chat sidebar by default when no specific action is selected
        return (
          <ChatSideBarContainer>
            <ChatSideBar />
          </ChatSideBarContainer>
        );
    }
  }, [selectedActionBarType]);

  return content;
};

const FeedActionBar = () => {
  const { setRightPanelContent } = useContext(LayoutContext);

  useEffect(() => {
    // Set custom content for the right panel
    setRightPanelContent(<FeedActionBarContent />, { openPanel: false });

    // Clear content when unmounting
    return () => setRightPanelContent(null);
  }, [setRightPanelContent]);

  // This component doesn't render anything directly
  // It just sets the right panel content via context
  return null;
};

export { FeedActionBarContent };
export default FeedActionBar;
